import React, { Component, PropTypes } from 'react';
import '../styles/main.scss';

/**
 * TODO
 *
 * @extends React.Component
 */
class AppContainer extends Component {
  render () {
    return (
      <React.Fragment>
        {this.props.routes}
      </React.Fragment>
    );
  }
}

AppContainer.propTypes = {
  // routes: PropTypes.object
}

export default AppContainer;



// WEBPACK FOOTER //
// ./src/containers/AppContainer.js